/**
 * Client-side validation helpers for MyInvestFolio forms.
 * Returns error message string or empty string if valid.
 */

export const validateRequired = (value, fieldName) => {
  if (!value || (typeof value === 'string' && !value.trim())) return `${fieldName} is required`;
  return '';
};

export const validateMinLength = (value, min, fieldName) => {
  if (value && value.trim().length < min) return `${fieldName} must be at least ${min} letters`;
  return '';
};

export const validateEmail = (value) => {
  if (!value) return 'Email is required';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) return 'Please enter a valid email address';
  return '';
};

export const validateUsername = (value) => {
  if (!value) return '';
  if (value.length < 3) return 'Username must be at least 3 letters';
  if (value.length > 20) return 'Username must be 20 letters or fewer';
  if (!/^[a-zA-Z0-9_]+$/.test(value)) return 'Username can only contain letters, numbers, and underscores';
  return '';
};

export const validatePassword = (value) => {
  if (!value) return 'Password is required';
  if (value.length < 8) return 'Password must be at least 8 characters';
  if (!/[A-Z]/.test(value)) return 'Password must include an uppercase letter';
  if (!/[a-z]/.test(value)) return 'Password must include a lowercase letter';
  if (!/[0-9]/.test(value)) return 'Password must include a number';
  if (!/[^A-Za-z0-9]/.test(value)) return 'Password must include a special character';
  return '';
};

export const validatePasswordMatch = (password, confirmPassword) => {
  if (!confirmPassword) return '';
  if (password !== confirmPassword) return 'Passwords do not match';
  return '';
};

export const validatePositiveNumber = (value, fieldName) => {
  if (value === '' || value === null || value === undefined) return `${fieldName} is required`;
  const num = Number(value);
  if (isNaN(num)) return `${fieldName} must be a number`;
  if (num <= 0) return `${fieldName} must be greater than 0`;
  return '';
};

export const validateNonNegativeNumber = (value, fieldName) => {
  if (value === '' || value === null || value === undefined) return `${fieldName} is required`;
  const num = Number(value);
  if (isNaN(num)) return `${fieldName} must be a number`;
  if (num < 0) return `${fieldName} cannot be negative`;
  return '';
};

export const validateOptionalPositiveNumber = (value, fieldName) => {
  if (!value && value !== 0) return '';
  const num = Number(value);
  if (isNaN(num)) return `${fieldName} must be a number`;
  if (num <= 0) return `${fieldName} must be greater than 0`;
  return '';
};

export const validatePercentage = (value, fieldName) => {
  if (!value && value !== 0) return '';
  const num = Number(value);
  if (isNaN(num)) return `${fieldName} must be a number`;
  if (num < 0 || num > 100) return `${fieldName} must be between 0 and 100`;
  return '';
};

export const validateDateNotFuture = (value, fieldName) => {
  if (!value) return '';
  const date = new Date(value);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  if (date > today) return `${fieldName} cannot be in the future`;
  return '';
};

export const validateDateAfter = (value, afterValue, fieldName, afterFieldName) => {
  if (!value || !afterValue) return '';
  if (new Date(value) <= new Date(afterValue)) return `${fieldName} must be after ${afterFieldName}`;
  return '';
};
